import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { tap } from 'rxjs/operators';
import { first } from 'rxjs/operators';
import { AppState } from 'src/app/reducers';
import { AlineacionToJustifyContent, Salutacion, SalutacionAlineacion, TipografiaToClass } from 'src/common/contenido';
import { GtagEvent } from 'src/common/gtagEvent';
import { SalutacionPageRequested } from '../store/salutacion/salutacion.actions';
import { allSalutacion, salutacionReady } from '../store/salutacion/salutacion.selectors';

@Component({
	selector: 'salutacion',
	templateUrl: './salutacion.component.html',
	styleUrls: ['./salutacion.component.scss']
})
export class SalutacionComponent implements OnInit {

	salutacion$: Observable<Salutacion[]>;
	ready$: Observable<boolean>;

	constructor( private store: Store<AppState>, private router: Router, private gtag: GtagEvent ) {
	}

	ngOnInit() {
		this.store.dispatch( new SalutacionPageRequested() );
		
		this.salutacion$ = this.store.select( allSalutacion );
		this.ready$ = this.store.select( salutacionReady );
	}

	private onSalutacionSelected( salutacion: Salutacion ) {
		if( salutacion.incluyeNota ) {
			this.router.navigateByUrl( '/principal/noticia/' + salutacion.rid );
			this.gtag.emit( 'ver-salutacion', 'salutacion', salutacion.rid );
		}
	}

	private getCardStyle( salutacion: Salutacion ): Object {
		let style: Object = null;

		if( salutacion != null ) {
			style = {};
			if( salutacion.fondo != null )
				style[ 'background-image' ] = `url( ${salutacion.fondo} )`;
			if( salutacion.color != null )
				style[ 'color' ] = salutacion.color;
			if( salutacion.alineacion != null )
				style[ 'justify-content' ] = AlineacionToJustifyContent[ salutacion.alineacion ];
			if( salutacion.incluyeNota )
				style[ 'cursor' ] = 'pointer';
		}

		return style;
	}

	private getCardClasses( salutacion: Salutacion ): String[] {
		let classes: String[] = null;
		if( salutacion != null && salutacion.tipografia != null ) {
			classes = [ TipografiaToClass[ salutacion.tipografia ] ];
			if( salutacion.incluyeNota )
				classes.push( 'nota' );
		}
		return classes;
	}

}
